import type { SportType } from "@aura-frontend/omnibus-az-client";

import type { FieldDimensions } from "./Field";

export const DIMENSIONS_BY_SPORT: Record<
  Extract<SportType, "baseball" | "softball">,
  Required<FieldDimensions>
> = {
  baseball: {
    diamondSizeFeet: 90,
    infieldAtFoulLineFeet: 90,
    fenceFirstBaseFeet: 325,
    fenceThirdBaseFeet: 325,
    fenceLeftFieldFeet: 325,
    fenceCenterFieldFeet: 360,
    fenceRightFieldFeet: 325,
  },
  softball: {
    diamondSizeFeet: 60,
    infieldAtFoulLineFeet: 60,
    fenceFirstBaseFeet: 200,
    fenceThirdBaseFeet: 200,
    fenceLeftFieldFeet: 200,
    fenceCenterFieldFeet: 220,
    fenceRightFieldFeet: 200,
  },
};

export const MOUND_DISTANCE_BY_SPORT: Record<
  Extract<SportType, "baseball" | "softball">,
  number
> = {
  baseball: 60.5,
  softball: 43,
};
